<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="helpPermissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="helpPermissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-scroll"></i></span>{{ 'StockInfoSearchComponent.Header.StockInfoSearchComponentHeader' | translate }}</h1>
  <p-card class="mx-2">
    <p-accordion [multiple]="true">
      <p-accordionTab
        header="{{ 'StockInfoSearchComponent.Header.SearchFormHeader' | translate }}"
        [(selected)]="isSearchFormOpen"
      >
        <ng-content *ngTemplateOutlet="settingSearchFormTemplate"></ng-content>
      </p-accordionTab>
      <p-accordionTab
        header="{{ 'StockInfoSearchComponent.Header.HeaderTable' | translate }}"
        [(selected)]="isHeaderTableOpen"
      >
        <ng-content *ngTemplateOutlet="settingHeaderTemplate"></ng-content>
      </p-accordionTab>
    </p-accordion>
  </p-card>
</div>

  <ng-template #settingSearchFormTemplate>
    <form [formGroup]="searchFormGroup">
      <div class="p-fluid formgrid grid">
        <div class="field col-3">
          <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{ 'StockInfoSearchComponent.SearchForm.HubPlantId' | translate }}</p>
          <laas-plant-dropdown
            [isSingle]="true"
            formControlName="hubPlantId">
          </laas-plant-dropdown>
        </div>
        <div class="field col-3">
          <label><span class="requiredStart">*</span>{{ 'StockInfoSearchComponent.SearchForm.Facility' | translate }}</label>
          <div class="item">
            <laas-facility-dropdown 
              formControlName="facility" 
              [isSingle]="true">
            </laas-facility-dropdown> 
          </div>
        </div>
        <div class="field col-3">
          <p class="mt-0 mb-2"><span class="requiredStart">*</span>{{'StockInfoSearchComponent.SearchForm.Storer' | translate }}</p>
          <p-dropdown formControlName="storer"
          placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [options]="storerMappingOptions" dataKey="value" appendTo="body"></p-dropdown>
        </div>
        <div class="field col-3">
          <label>{{ 'StockInfoSearchComponent.SearchForm.Brand' | translate }}</label>
          <div class="item">
          <p-dropdown formControlName="brand" optionLabel="label" optionValue="value"[showClear]="true"
          [options]="brandOptions" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [filter]="true" styleClass="p-text-left" ></p-dropdown>
          </div>
        </div>
        <div class="field col-3">
          <label>{{ 'StockInfoSearchComponent.SearchForm.SKU' | translate }}</label>
          <input type="text" pInputText formControlName="sku"/>
        </div>
        <div class="field col-3">
          <label>{{ 'StockInfoSearchComponent.SearchForm.DateCode' | translate }}</label>
          <input type="text" pInputText formControlName="dateCode"/>
        </div>
        <div class="field col-3">
          <p class="mt-0 mb-2">{{'StockInfoSearchComponent.SearchForm.SpecLocType' | translate }}</p>
          <p-dropdown formControlName="specLocType" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [options]="specLocTypeOptions"></p-dropdown>
        </div>
        <div class="field col-12">
          <small>
            <strong class="p-invalid">
              {{ 'StockInfoSearchComponent.Message.SearchFormNotification' | translate }}
            </strong>
          </small>
        </div>
      </div>
      <div>
        <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick()">
        </button>
        <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" type="reset" (click)="resetBtnClick()"
        class="p-button-secondary ml-2"></button>
      </div>
    </form>
  </ng-template>


  <ng-template #settingHeaderTemplate>
    <div class="mt-2">
      <laas-data-table
          #headerTable
          [value]="searchResults"
          [defaultColumns]="columns"
          [loading]="isLoading"
          [totalRecords]="this.pageInfo.totalRecords"
          (tableOnSort)="tableSort($event)"
          [tableKey]="preferenceKey"
          (tableOnPage)="tablePageChange($event)"
          [lazy]="true"
          [rowsPerPageOptions]="[5,10,25,50,100]"
        >
        <ng-template pTemplate="caption">
          <button pButton pRipple label="{{ 'FSCSSCSetting.Button.Export' | translate }}" [disabled]="searchResults.length === 0" (click)="exportBtnClick($event)" class="ml-2">
          </button>
        </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <td *ngFor="let col of columns">
          <ng-container [ngSwitch]="col.field">
            <ng-container *ngSwitchDefault>
              <div class="overflow-text">
                {{ rowData[col.field] | replaceNullWith : "-" }}
              </div>
            </ng-container>
          </ng-container>
        </td>
      </ng-template>
      </laas-data-table>
    </div>
  </ng-template>
<help-dock
  [permissionCode]="helpPermissionCode"
  [lang]="currentLang">
</help-dock>
